import { SvgIconProps } from './icon-props';

export default function CaretDown({ height = 7, width = 15 }: SvgIconProps) {
	return (
		<svg viewBox="0 0 15 7" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
			<path
				d="m0 0 6.75 6.3.75.7.75-.7L15 0h-1.5l-6 5.6-6-5.6z"
				fill="#231F20"
				fillRule="evenodd"
			/>
		</svg>
	);
}
